import React from 'react';
import { FemEntityLanding } from './pages/FemEntityLanding';
import { InvestorsPage } from './pages/InvestorsPage';
export function App() {
  const path = window.location.pathname;
  if (path === '/investors') {
    return <InvestorsPage data-id="element-0" />;
  }
  return <FemEntityLanding data-id="element-1" />;
}